import { DateTime } from 'luxon'

const ACTIVE_ANNIVERSARY_DAYS = 7

// Returns null if it is not currently the user's anniversary day, otherwise returns the
// number of years they've been a member
export default function getActiveAnniversary(memberSince: DateTime): number | null {
  const now = DateTime.utc()
  const { years, days } = now.diff(memberSince, ['year', 'day']).toObject()

  if (years == null || years === 0) {
    return null
  }

  if (days != null && days < ACTIVE_ANNIVERSARY_DAYS) {
    return years
  }

  return null
}
